// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-list[data-v-a7da851a] {\n  border-left: 2px solid rgb(236 236 236);\n  border-right: 2px solid rgb(236 236 236);\n}\n", ""]);
// Exports
module.exports = exports;
